(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    /* =========================================================
       ZEROX PRODUCT MEDIA
       ========================================================= */

    function initZeroXProductMedia() {
      const stages = document.querySelectorAll('.zx-product-media-stage');

      if (!stages.length) {
        return;
      }

      stages.forEach(function (stage) {
        const gallery = stage.querySelector('.zx-media-gallery-inner');

        if (!gallery) {
          return;
        }

        /* =====================================================
           FIND MAIN SLIDESHOW
           ===================================================== */

        const slideshowContainer = gallery.querySelector('slideshow-container');

        if (!slideshowContainer) {
          return;
        }

        /* =====================================================
           MOBILE IMAGE HEIGHT FIX
           MATCH PARENT TO ACTUAL IMAGE
           ===================================================== */

        function syncMobileMediaHeight() {
          if (!window.matchMedia('(max-width: 767px)').matches) {
            slideshowContainer.style.height = '';

            const slideshowComponent = slideshowContainer.closest('slideshow-component');

            if (slideshowComponent) {
              slideshowComponent.style.height = '';
              slideshowComponent.style.minHeight = '';
              slideshowComponent.style.maxHeight = '';
            }

            return;
          }

          const activeSlide =
            slideshowContainer.querySelector('slideshow-slide[aria-current="true"]') ||
            slideshowContainer.querySelector('slideshow-slide:not([hidden])') ||
            slideshowContainer.querySelector('slideshow-slide');

          if (!activeSlide) {
            return;
          }

          const image = activeSlide.querySelector('.product-media-container--image img');

          if (!image) {
            return;
          }

          const slideshowComponent = slideshowContainer.closest('slideshow-component');

          function applyHeight() {

  const imageHeight =
    image.getBoundingClientRect().height;

  if (
    imageHeight > 0
  ) {

    /* =================================================
       MAIN PARENT
       IMAGE HEIGHT + EXTRA MOBILE SPACE
       ================================================= */
if (
  slideshowComponent &&
  window.matchMedia('(max-width: 767px)').matches
) {

  const extraMobileHeight = 90;

  const totalMobileHeight =
    imageHeight + extraMobileHeight;

  slideshowComponent.style.setProperty(
    'height',
    totalMobileHeight + 'px',
    'important'
  );

  slideshowComponent.style.setProperty(
    'min-height',
    totalMobileHeight + 'px',
    'important'
  );

  slideshowComponent.style.setProperty(
    'max-height',
    totalMobileHeight + 'px',
    'important'
  );

}


    /* =================================================
       SLIDESHOW CONTAINER
       KEEP EXACT IMAGE HEIGHT
       ================================================= */

    slideshowContainer.style.setProperty(
      'height',
      imageHeight + 'px',
      'important'
    );

    slideshowContainer.style.setProperty(
      'min-height',
      imageHeight + 'px',
      'important'
    );

    slideshowContainer.style.setProperty(
      'max-height',
      imageHeight + 'px',
      'important'
    );

  }

}

          if (image.complete) {
            requestAnimationFrame(applyHeight);
          } else {
            image.addEventListener(
              'load',
              function () {
                requestAnimationFrame(applyHeight);
              },
              {
                once: true,
              }
            );
          }
        }

        /* =====================================================
           INITIAL MOBILE HEIGHT
           ===================================================== */

        syncMobileMediaHeight();

        /* =====================================================
           WATCH IMAGE SIZE CHANGES
           ===================================================== */

        if (typeof ResizeObserver !== 'undefined') {
          const imageResizeObserver = new ResizeObserver(function () {
            syncMobileMediaHeight();
          });

          const images = slideshowContainer.querySelectorAll('.product-media-container--image img');

          images.forEach(function (image) {
            imageResizeObserver.observe(image);
          });
        }

        /* =====================================================
           RESIZE
           ===================================================== */

        window.addEventListener('resize', function () {
          syncMobileMediaHeight();
        });

        /* =====================================================
           WATCH SLIDE CHANGES
           ===================================================== */

        const slideObserver = new MutationObserver(function () {
          setTimeout(syncMobileMediaHeight, 30);
        });

        slideObserver.observe(slideshowContainer, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-current', 'hidden', 'class'],
        });

        /* =====================================================
           MOVE BADGES INTO MAIN IMAGE
           ===================================================== */

        const badges = gallery.querySelector('[data-zx-media-badges]');

        if (badges && badges.parentElement !== slideshowContainer) {
          slideshowContainer.appendChild(badges);
        }

        /* =====================================================
           MOVE TAP TO DIM INTO MAIN IMAGE
           ===================================================== */

        const dimButton = gallery.querySelector('[data-zx-dim-button]');

        if (dimButton && dimButton.parentElement !== slideshowContainer) {
          slideshowContainer.appendChild(dimButton);
        }

        /* =====================================================
           DIM BUTTON
           ===================================================== */

        if (!dimButton) {
          return;
        }

        if (dimButton.dataset.zxReady === 'true') {
          return;
        }

        dimButton.dataset.zxReady = 'true';

        dimButton.addEventListener('click', function () {
          /* MOBILE ONLY */

          if (!window.matchMedia('(max-width: 749px)').matches) {
            return;
          }

          const isDimmed = stage.classList.toggle('zx-media-is-dimmed');

          dimButton.setAttribute('aria-pressed', isDimmed ? 'true' : 'false');

          const text = dimButton.querySelector('[data-zx-dim-text]');

          if (text) {
            text.textContent = isDimmed ? 'Light On' : 'Tap to Dim';
          }
        });
      });
    }

    /* =========================================================
       INITIAL LOAD
       ========================================================= */

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initZeroXProductMedia);
    } else {
      initZeroXProductMedia();
    }

    /* =========================================================
       SHOPIFY THEME EDITOR
       ========================================================= */

    document.addEventListener('shopify:section:load', function () {
      setTimeout(initZeroXProductMedia, 300);
    });

    document.addEventListener('shopify:section:reorder', function () {
      setTimeout(initZeroXProductMedia, 300);
    });

    document.addEventListener('shopify:section:select', function () {
      setTimeout(initZeroXProductMedia, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
